<!-- ================管理端-创建编辑读书会====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{!activityId?'创建主题活动':'编辑主题活动'}}</div>
        </div>
        <div class="create-content-container">
            <el-form style="padding-bottom: 15px;" ref="form" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="15">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动名称" prop="activityName">
                                    <el-input v-model="form.activityName" placeholder="请输入活动名称"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="学段" prop="periodList">
                                    <el-select multiple v-model="form.periodList" placeholder="请选择">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="年级段" prop="activityGradeList">
                                    <el-select multiple  v-model="form.activityGradeList" placeholder="请选择">
                                        <el-option v-for="item in eventGradeList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>

                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属五馆" prop="museumKey">
                                    <el-select @change="changeMuseum" v-model="form.museumKey" placeholder="请选择所属馆">
                                        <el-option v-for="item in museumList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属主题" prop="activityItem">
                                    <el-select v-model="form.activityItem" placeholder="请选择主题">
                                        <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName+' '+item.itemDesc"
                                                   :value="item.itemId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-show="this.form.museumKey === '4'">
                                <el-form-item label="四季主题" prop="seasonItem">
                                    <el-select v-model="form.seasonItem" placeholder="请选择主题">
                                        <el-option v-for="item in seasonItemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                                   :value="item.itemId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动年龄" prop="activityAge">
                                    <el-input v-model="form.activityAge" placeholder="请输入活动年龄说明"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="14">
                                <el-form-item label="活动时长" prop="activityTime">
                                    <el-input v-model="form.activityTime" placeholder="请输入活动时长"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="8">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动封面" prop="activityCover" label-position="top" >
                                    <el-upload class="event-avatar-uploader"
                                               :action="serviceUrl+'/businessservice/book/uploadCover'" :show-file-list="false"
                                               accept=".jpg,.png,.jpeg"
                                               :on-success="handleAvatarSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                        <img alt="" v-if="form.activityCover" :src="form.activityCover" class="avatar" style="position:absolute" />
                                        <el-icon class="event-avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                            <Plus />
                                        </el-icon>
                                    </el-upload>
                                    <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="18">
                        <el-form-item label="活动说明" prop="activityDesc">
                            <t-editor v-model="form.activityDesc" :height="400" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="18">
                        <el-form-item label="活动目标" prop="activityAim">
                            <t-editor v-model="form.activityAim" :height="400" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="活动资料" prop="">
                            <el-upload v-model:file-list="fileList"
                                       :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/museumActivity/uploadFile'"
                                       :on-change="handleFileChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx,.mp4,.flv,.wmv"
                                       :before-upload="beforeFileUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx,.mp4,.flv,.wmv格式文件，大小需在500M以内。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/dict";
import {createMuseumActivity,updateMuseumActivity,infoMuseumActivity} from "@/api/admin/museumActivity"
import {listItem} from "@/api/admin/item";
import TEditor from "@/components/TEditor.vue";

export default {
    components: {TEditor},
    name: "museumActivityCreate",
    data() {
        return {
            isShowBook:false,
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            activityId:'',
            periodList:[],
            gradeList:[],
            queryItemParams:{
                itemType:1,
                museumKey:'1',
            },
            itemList:[],
            seasonItemList:[],
            eventGradeList:[],
            museumList:[],
            fileList:[],
            // 表单参数
            form: {
                activityId:'',
                activityCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
                activityName:'',
                activityAim:'',
                activityDesc:'',
                appActivityAim:'',
                appActivityDesc:'',
                activityItem:'',
                seasonItem:'',
                museumKey:'',
                periodKey:'',
                periodList:'',
                activityTime:'',
                activityGrade:'',
                activityGradeList:'',
                activityAge:'',
                fileUrls:'',
            },
            rules:{
                activityName: [{ required: true, message: "请输入活动名称", trigger: "blur" },],
                activityCover: [{ required: true, validator: this.checkCoverValidator  },],
                activityItem: [{ required: true, message: "请选择所属主题", trigger: "change" },],
                museumKey: [{ required: true, message: "请选择五馆", trigger: "change" },],
                // periodKey: [{ required: true, message: "请选择学段", trigger: "change" },],
                // eventGrade: [{ required: true, message: "请选择年级段", trigger: "change" },],
                // activityTime: [{ required: true, message: "请输入活动时长", trigger: "blur" },],
                activityAim: [{ required: true, message: "请输入活动目标", trigger: "blur" },],
                activityDesc: [{ required: true, message: "请输入活动说明", trigger: "blur" },],
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.handleQueryDict();
        this.handleQueryItem();
        this.handleQuerySeasonItem();
    },
    mounted() {
        if (this.$route.query.activityId) {
            this.activityId = this.$route.query.activityId
            this.queryActivityInfo()
        }
    },
    methods: {
        backList(){
            this.$router.push({
                path: "/museumActivity",
            });
        },
        submitForm(){
            const fileList = [];
            this.fileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.form.periodKey = this.form.periodList.toString();
                    this.form.activityGrade = this.form.activityGradeList.toString();
                    this.form.fileUrls = fileList.toString();
                    // 页面未单独维护App端活动目标、活动说明，与PC端保持一致
                    this.form.appActivityAim = this.formatAppRichText(this.form.activityAim);
                    this.form.appActivityDesc = this.formatAppRichText(this.form.activityDesc);
                    if (!this.activityId) {
                        createMuseumActivity(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }else {
                        this.form.eventId = this.activityId;
                        updateMuseumActivity(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }
                }
            });
        },
        formatAppRichText(html){
            var text = html || '';
            text = text.replace(/<video/gi,"<video style='width:100% !important;height:30% !important;background:#333 !important;'")
            text = text.replace(/<img/gi,"<img style='width: 100% !important;height:auto !important;vertical-align: middle !important;max-height:100%;margin:0 auto !important;'")
            text = text.replace(/<p style="/gi,'<p style="text-indent: unset !important;')
            if (text && !text.includes('<div')){
                text = "<div style=\"padding: 0 10px!important;\">" + text +"</div>";
            }
            return text;
        },
        handleQueryItem(){
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleQuerySeasonItem(){
            this.queryItemParams.itemType = 4;
            this.queryItemParams.museumKey = "4"
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.seasonItemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.eventGradeList = res.data.data;
            })
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        queryActivityInfo(){
            infoMuseumActivity({ activityId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    this.fileList = [];
                    this.form.fileList.forEach(e => {
                        this.fileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    this.handleMuseumItem();
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        changeMuseum(){
            this.form.activityItem = '';
            this.form.seasonItem = '';
            this.handleMuseumItem();
        },
        handleMuseumItem(){
            this.queryItemParams.museumKey = this.form.museumKey;
            //阅读拓展馆
            if (this.form.museumKey === '1'){
                this.queryItemParams.itemType = 1;
            }
            //科技艺术馆
            if (this.form.museumKey === '2'){
                this.queryItemParams.itemType = 2;
            }
            //非遗文化馆
            if (this.form.museumKey === '3'){
                this.queryItemParams.itemType = 3;
            }
            //劳动实践馆
            if (this.form.museumKey === '4'){
                this.queryItemParams.itemType = 5;
            }
            //自然研学馆
            if (this.form.museumKey === '5'){
                this.queryItemParams.itemType = 6;
            }
            this.handleQueryItem();
        },
        /*==========封面信息===========*/
        checkCoverValidator(rule, value, callback) {
            if (this.form.eventCover !== '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.form.activityCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /*==========文件相关===========*/
        handleRemove(file, uploadFiles) {},
        handleFileChange(file) {},
        beforeFileUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'application/vnd.ms-powerpoint' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'||
              rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
              rawFile.type == 'application/msword'||
              rawFile.type === 'video/mp4' ||
                rawFile.type === 'video/x-flv' ||
                rawFile.type === 'video/x-ms-wmv')) {
                this.$message.error('不支持的文件格式')
                return false
            } else if (rawFile.size / 1024 / 1024 > 500) {
                this.$message.error('文件大小不能超过500M')
                return false
            }
            return true
        },
    },
}
</script>
<style>
.event-avatar-uploader .avatar {
    height: 152px;
    width: 270px;
    display: block;
    object-fit: cover;
}
.event-avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.event-avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.event-avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 152px;
    width: 270px;
    text-align: center;
}
.sel-video-contain{
    width: 800px;
    height: 75vh;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
}
.sel-info-contain{
    width: 800px;
    padding-top: 10px;
    height: 40px;
    display: flex;
}
.info-item1{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-family: sans-serif;

}
.info-item2{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
}
.info-item3{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
    margin-left: 20px;
}
.l-second-container{
    width: 100%;
    height: 30px;
    padding: 0 10px 0 0;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
}
.second-box1{
    width: 20px;
}
.second-box2{
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #377f7f;
}
.second-box3{
    width: calc(100% - 120px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #377f7f;

}
.l-tree-container{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.form-box{
    padding-top: 10px;
}
.r-container{
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.vl-container{
    width: 100%;
    height: calc(100% - 60px)!important;
}
.video-box{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}
.video-item{
    width: 20%;
    height: 235px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
}
.item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -145px;
    padding-top: 30px;
    box-sizing: border-box;
}
.player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.video-cover{
    width: 100%;
    height: 180px;
}
.video-name{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #b1b1b1;
    padding-top: 5px;
}
.video-name-c{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #377f7f;
    padding-top: 5px;
}
.v-list-container{
    width: 800px;
    height: auto;
    padding: 10px 10px 10px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.v-list-item{
    width: 20%;
    height: 215px;
    padding: 0 10px 10px 10px;
    cursor: pointer;
}
.v-t{
    width: 100%;
    height: 30px;
    display: flex;
    padding-top: 5px;
}
.v-t-l{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    color: #121212;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.v-t-r{
    width: 20px;
    height: 22px;
    cursor: pointer;
    margin-top: 3px;
}
</style>
